import { MessageContentCategory, SectionType, MessageContentType, ConversationStatus } from '@rocketlane/rocket-llm';
export const getSendMessagePayload = ({ title, messageSections, policyType, policySubType, conversationId })=>{
    return {
        conversation_id: conversationId,
        visibility: 'public',
        title,
        message: {
            sections: messageSections,
            message_metadata: {
                agent_name: 'policy_agent',
                agent: 'policy_agent',
                agent_type: 'policy_generation',
                policy_type: policyType,
                policy_sub_type: policySubType,
                use_v3: true
            }
        },
        conversation_metadata: {
            agent_name: 'policy_agent',
            agent: 'policy_agent',
            agent_type: 'policy_generation',
            policy_type: policyType,
            policy_sub_type: policySubType,
            use_v3: true
        }
    };
};
export const getCreateConversationPayload = ({ message, projectId })=>{
    return {
        message: {
            sections: [
                {
                    type: SectionType.TEXT,
                    left_content: {
                        type: MessageContentType.TEXT,
                        value: message
                    }
                }
            ]
        },
        conversation_metadata: {
            source: 'web_app',
            project_id: projectId
        }
    };
};
export const getAnalyticsSendMessagePayload = ({ message, conversationId, accountId, userId, sectionType, agent_name, conversation_metadata, message_metadata, message_sections, mountedPanels })=>{
    const agentName = agent_name || (conversation_metadata === null || conversation_metadata === void 0 ? void 0 : conversation_metadata.agent_name);
    const mergedConversationMetadata = {
        ...conversation_metadata !== null && conversation_metadata !== void 0 ? conversation_metadata : {},
        ...agentName ? {
            agent_name: agentName
        } : {}
    };
    const hasAnyMetadata = Object.keys(mergedConversationMetadata).length > 0;
    const hasMessageMetadata = message_metadata != null && Object.keys(message_metadata).length > 0;
    const panels = mountedPanels && mountedPanels.length > 0 ? mountedPanels.map((p)=>{
        var _p_conversationId;
        var _p_clientActions;
        return {
            conversationId: (_p_conversationId = p.conversationId) !== null && _p_conversationId !== void 0 ? _p_conversationId : conversationId,
            tabId: p.tabId,
            widgetId: p.widgetId,
            appId: p.appId,
            appVersionId: p.appVersionId,
            installationId: p.installationId,
            ...p.resourceUri ? {
                resourceUri: p.resourceUri
            } : {},
            ...p.componentId ? {
                componentId: p.componentId
            } : {},
            ...((_p_clientActions = p.clientActions) === null || _p_clientActions === void 0 ? void 0 : _p_clientActions.length) ? {
                clientActions: p.clientActions
            } : {}
        };
    }) : undefined;
    const mergedMessageMetadata = {
        ...message_metadata !== null && message_metadata !== void 0 ? message_metadata : {},
        ...panels ? {
            mountedPanels: panels
        } : {}
    };
    const payload = {
        conversation_id: conversationId,
        account_id: accountId,
        user_id: userId,
        message: {
            ...hasMessageMetadata || panels ? {
                message_metadata: mergedMessageMetadata
            } : {},
            sections: message_sections || [
                {
                    type: sectionType || 'text',
                    left_content: {
                        type: 'text',
                        category: MessageContentCategory.SUMMARY,
                        value: message
                    }
                }
            ]
        },
        ...hasAnyMetadata ? {
            conversation_metadata: mergedConversationMetadata
        } : {}
    };
    return payload;
};
export const getFeedbackPayload = ({ messageId, feedbackType, feedbackCategory, feedbackText })=>{
    return {
        message_id: messageId,
        feedback_type: feedbackType,
        feedback_category: feedbackCategory,
        feedback_text: feedbackText
    };
};
export const convertAnalyticsResponseToConversation = (data)=>{
    var _data_conversation_updated_at, _data_has_more, _data_page, _data_page_size, _data_total;
    const transformedMessages = (data.messages || []).map((msg)=>{
        var _msg_updated_at;
        const sections = (msg.sections || []).map((section, idx)=>{
            var _section_left_content;
            const messageSection = {
                id: section.id,
                order_index: idx,
                type: section.type || 'text',
                title: ((_section_left_content = section.left_content) === null || _section_left_content === void 0 ? void 0 : _section_left_content.title) || undefined,
                status: section.status,
                timestamp: section.timestamp ? new Date(section.timestamp) : undefined
            };
            if (section.left_content) {
                messageSection.left_content = {
                    type: section.left_content.type || 'text',
                    category: 'summary',
                    title: section.left_content.title || undefined,
                    value: section.left_content.value || ''
                };
            }
            if (section.right_content) {
                messageSection.right_content = {
                    type: section.right_content.type || 'text',
                    category: 'summary',
                    title: section.right_content.title || undefined,
                    value: section.right_content.value || ''
                };
            }
            return messageSection;
        });
        return {
            id: msg.id,
            conversation_id: msg.conversation_id,
            user_id: msg.user_id,
            type: msg.type,
            sections,
            version: msg.version || 1,
            is_edited: msg.is_edited || false,
            agents_ids: msg.agents_ids || [],
            metadata: msg.metadata || {},
            is_streaming: msg.is_streaming || false,
            is_deleted: msg.is_deleted || false,
            feedback_type: msg.feedback_type || undefined,
            has_feedback: msg.has_feedback || msg.feedback_type != null,
            created_at: msg.created_at,
            updated_at: (_msg_updated_at = msg.updated_at) !== null && _msg_updated_at !== void 0 ? _msg_updated_at : undefined
        };
    });
    return {
        conversation_id: data.conversation.conversation_id,
        title: data.conversation.title || 'Analytics Conversation',
        user_ids: data.conversation.user_ids,
        status: data.conversation.status === 'active' ? ConversationStatus.Active : ConversationStatus.InProgress,
        is_deleted: data.conversation.is_deleted,
        active_version: data.conversation.active_version,
        messages: transformedMessages,
        metadata: data.conversation.metadata,
        tags: data.conversation.tags,
        created_at: data.conversation.created_at,
        updated_at: (_data_conversation_updated_at = data.conversation.updated_at) !== null && _data_conversation_updated_at !== void 0 ? _data_conversation_updated_at : undefined,
        has_more: (_data_has_more = data.has_more) !== null && _data_has_more !== void 0 ? _data_has_more : false,
        page: (_data_page = data.page) !== null && _data_page !== void 0 ? _data_page : 1,
        page_size: (_data_page_size = data.page_size) !== null && _data_page_size !== void 0 ? _data_page_size : 20,
        total: (_data_total = data.total) !== null && _data_total !== void 0 ? _data_total : 0
    };
};
